/* eslint no-use-before-define: 0 */
export const LABELS = {
  ACTIVE: 'Actief',
  BACK: 'Terug',
  CREDIT: 'Crediteer',
  CITY: 'Stad',
  CLIENT: 'Klant',
  CLIENT_CREATE: 'Nieuwe klant',
  CLIENTS: 'Klanten',
  CLIENT_NAME: 'Klantnaam',
  CLIENT_CODE: 'Klantcode',
  CLIENT_EDIT: 'Klant bewerken',
  CLIENT_SAVE: 'Klant opslaan',
  CLIENT_DELETE: 'Klant verwijderen',
  CLIENT_TYPE: 'Type klant',
  PARTICULIER: 'Particulier',
  ZAKELIJK: 'Zakelijk',
  CANCEL: 'Annuleren',
  COC: 'KVK nummer',
  CONTINUE: 'Ga door',
  COMPANY: 'Bedrijf',
  COMPANY_NAME: 'Bedrijfsnaam',
  COMPANY_INFO: 'Bedrijfsgegevens',
  CHANGES_SAVED: 'Wijzigingen opgeslagen',
  CONFIRM_REMOVE_CONTACT_TITLE: 'Contactpersoon verwijderen?',
  CONFIRM_EXIT_PAGE_TITLE: 'Pagina verlaten?',
  CONFIRM_EXIT_PAGE_TEXT: `De wijzigingen zijn nog niet opgeslagen. <br />
  Weet je zeker dat je deze pagina wilt verlaten?
  `,
  CONFIRM_DUPLICATE_INVOICE_TITLE: 'Factuur dupliceren?',
  CONFIRM_DUPLICATE_INVOICE_TEXT:
    'Er wordt een kopie gemaakt van deze factuur als concept. \
    Je kunt de kopie daarna bewerken en aanpassen. Wil je doorgaan?',
  CONFIRM_DUPLICATE_QUOTATION_TITLE: 'Offerte dupliceren?',
  CONFIRM_DUPLICATE_QUOTATION_TEXT:
    'Er wordt een kopie gemaakt van deze offerte als concept. \
    Je kunt de kopie daarna bewerken en aanpassen. Wil je doorgaan?',
  CONFIRM_DELETE_CLIENT_TITLE: 'Klant verwijderen?',
  CONFIRM_DELETE_CLIENT_TEXT:
    'Weet je zeker dat je deze klant wilt verwijderen? \
    Deze actie kan niet ongedaan worden gemaakt. Alle gekoppelde facturen en offertes blijven behouden.',
  COUNTRY: 'Land',
  DASHOARD: 'Dashboard',
  DOWNLOAD: 'Download',
  DESCRIPTION: 'Beschrijving',
  DATE: 'Datum',
  EMAIL: 'E-mail',
  FINISH: 'Afronden',
  FINALISE: 'Maak definitief',
  HOUSE_NUMBER: 'Huisnummer',
  HOUSE_NUMBER_ADDITION: 'Toevoeging',
  INVOICE: 'Factuur',
  INVOICES: 'Facturen',
  INVOICE_NUMBER: 'Factuur nummer',
  INVOICE_SAVE: 'Factuur opslaan',
  INVOICE_EDIT: 'Factuur bewerken',
  LOGIN: 'Inloggen',
  LOGOUT: 'Uitloggen',
  MY_OUTVOICE: 'Mijn Outvoice',
  MY_PROFILE: 'Mijn profiel',
  MY_COMPANY: 'Mijn onderneming',
  MY_ACCOUNT: 'Mijn account',
  NAME: 'Naam',
  NEXT: 'Volgende',
  OUTVOICE: 'Outvoice',
  PASSWORD: 'Wachtwoord',
  PASSWORD_AGAIN: 'Nogmaals wachtwoord',
  PASSWORD_FORGOT: 'Wachtwoord vergeten',
  PASSWORD_REQUIRED: 'Vul je wachtwoord in',
  CONFIRM_PASSWORD_REQUIRED: 'Vul je wachtwoord nogmaals in',
  CONFIRM_PASSWORD_DOES_NOT_MATCH: 'De wachtwoorden komen niet overeen',
  POSTAL_CODE: 'Postcode',
  PRICE: 'Prijs',
  PRICE_PER_HOUR: 'Uurprijs',
  EXPIRES_AFTER: 'Verloopt na',
  QUOTATION: 'Offerte',
  REFERENCE: 'Referentie',
  QUANTITY: 'Aantal',
  QUOTATION_REFERENCE: 'Offerte referentie',
  INVOICE_EXPIRES_AFTER: 'Factuur verloopt na',
  QUOTATION_EXPIRES_AFTER: 'Offerte verloopt na',
  QUOTES: 'Offertes',
  REGISTER: 'Registreer',
  REGISTER_FORM_TITLE: 'Registreer je gratis account',
  NO_ACCOUNT: 'Nog geen account?',
  ALREADY_HAVE_ACCOUNT: 'Al een account?',
  SEARCH: 'Zoeken',
  SEND: 'Versturen',
  SEND_EMAIL: 'E-mail versturen',
  SETTINGS: 'Instellingen',
  SETTINGS_SAVE: 'Opslaan',
  STATUS: 'Status',
  PAYMENT_STATUS: 'Betaalstatus',
  INVOICE_STATUS: 'Factuurstatus',
  QUOTATION_STATUS: 'Offertestatus',
  PASSWORD_CHANGE: 'Wijzig wachtwoord',
  PROFILE_SAVE: 'Profiel opslaan',
  SUB_TOTAL: 'Totaal (ex BTW)',
  SUBJECT: 'Betreft',
  STREET: 'Straat',
  TAX_YEAR: 'Boekjaar',
  TAX_NUMBER: 'BTW-ID',
  TOTAL: 'Totaal (inc BTW)',
  UPDATED_AT: 'Laatst gewijzigd',
  USERS: 'Gebruikers',
  VAT: 'BTW',
  USERNAME: 'Gebruikersnaam',
  USERNAME_REQUIRED: 'Vul je e-mailadres in',
  CATALOG: 'Catalogus',
  PRODUCT: 'Product',
  PRODUCTS: 'Producten',
  PRODUCT_NAME: 'Productnaam',
  PRODUCT_CREATE: 'Nieuw product',
  PRODUCT_EDIT: 'Product bewerken',
  PRODUCT_SAVE: 'Product opslaan',
  PRODUCT_DELETE: 'Product verwijderen',
  PRODUCT_DESCRIPTION: 'Productomschrijving',
  UNIT_PRICE: 'Eenheidsprijs',
  UNIT: 'Eenheid',
  SKU: 'Artikelnummer',
  SELECT_FROM_CATALOG: 'Kies uit catalogus',
  TITLE: 'Titel',
  EXTRA_DESCRIPTION: 'Omschrijving (optioneel)',
  LOGO_UPLOAD: 'Logo uploaden',
  LOGO_CHANGE: 'Logo wijzigen',
  LOGO_DELETE: 'Logo verwijderen',
  LOGO_DELETE_TITLE: 'Logo verwijderen',
  LOGO_DELETE_TEXT:
    'Weet je zeker dat je het bedrijfslogo wilt verwijderen? ' +
    'Deze actie kan niet ongedaan worden gemaakt.',
  LOGO_DELETED_SUCCESS: 'Logo succesvol verwijderd',
  LOGO_DELETE_FAILED: 'Logo verwijderen mislukt',
}

export const TOOLTIPS = {
  // Global Actions
  CANCEL_ESC: 'Wijzigingen ongedaan maken (Esc)',
  SAVE_SHORTCUT: 'Wijzigingen opslaan (Ctrl/Cmd + S)',
  SEND_EMAIL: 'E-mail versturen naar klant',

  // Settings & Profile
  SAVE_SETTINGS: 'Instellingen opslaan',
  SAVE_PROFILE: 'Profiel wijzigingen opslaan',
  CHANGE_PASSWORD: 'Wachtwoord wijzigen',
  DELETE_PROFILE: 'Profiel permanent verwijderen',

  // Email
  SAVE_EMAIL_TEMPLATE: 'E-mail template opslaan',
  CREATE_EMAIL_TEMPLATE: 'Nieuw e-mailsjabloon aanmaken',
  EDIT_EMAIL_TEMPLATE: 'E-mailsjabloon bewerken',
  DELETE_EMAIL_TEMPLATE: 'E-mailsjabloon verwijderen',
  TEST_SMTP_CONNECTION: 'SMTP verbinding testen',
  VIEW_EMAIL_LOGS: 'E-mail logboek bekijken',
  CHANGE_EMAIL: 'E-mailadres wijzigen',
  RESEND_EMAIL_VERIFICATION: 'Verificatie e-mail opnieuw versturen',
  CANCEL_EMAIL_CHANGE_REQUEST: 'E-mailadres wijzigingsverzoek annuleren',

  // Client Management
  CREATE_NEW_CLIENT: 'Nieuwe klant aanmaken',
  ADD_NEW_CLIENT_INLINE: 'Nieuwe klant toevoegen vanuit formulier',
  SAVE_CLIENT: 'Klant wijzigingen opslaan',
  DELETE_CLIENT: 'Klant permanent verwijderen',
  EDIT_CLIENT: 'Klantgegevens bewerken',

  // Client Contacts
  ADD_NEW_CONTACT: 'Nieuwe contactpersoon toevoegen',
  ADD_CONTACT: 'Contactpersoon toevoegen',
  EDIT_CONTACT: 'Contactpersoon bewerken',
  DELETE_CONTACT: 'Contactpersoon verwijderen',
  CANCEL_ADD_CONTACT: 'Toevoegen annuleren',
  SAVE_CONTACT_UPDATE: 'Contactpersoon wijzigingen opslaan',
  CANCEL_CONTACT_UPDATE: 'Wijzigingen annuleren',

  // Product Management
  CREATE_NEW_PRODUCT: 'Nieuw product aanmaken',
  SAVE_PRODUCT: 'Product wijzigingen opslaan',
  DELETE_PRODUCT: 'Product permanent verwijderen',
  EDIT_PRODUCT: 'Product bewerken',
  SELECT_FROM_CATALOG: 'Kies een product uit de catalogus',

  // Invoice Management
  CREATE_NEW_INVOICE: 'Nieuwe factuur aanmaken',
  SAVE_INVOICE: 'Factuur wijzigingen opslaan',
  DELETE_INVOICE: 'Factuur permanent verwijderen',
  DUPLICATE_INVOICE: 'Maak een kopie van deze factuur',
  EDIT_INVOICE: 'Factuur bewerken',
  FINALIZE_INVOICE: 'Factuur definitief maken - kan niet ongedaan gemaakt worden',
  CHANGE_PAYMENT_STATUS: 'Betaalstatus wijzigen',
  CREATE_CREDIT_NOTE: 'Creditnota aanmaken voor deze factuur',
  SEND_INVOICE_EMAIL: 'Factuur per e-mail versturen',
  CONFIGURE_SMTP_FIRST: 'Configureer eerst SMTP-instellingen in Instellingen > Email',
  ADD_BANK_ACCOUNT_FIRST: 'Voeg eerst bankgegevens toe in Instellingen > Bedrijf',
  DOWNLOAD_INVOICE_PDF: 'Factuur als PDF downloaden',
  OPEN_INVOICE_SETTINGS: 'Factuurinstellingen openen',
  BULK_DOWNLOAD_INVOICES: 'Geselecteerde facturen als ZIP downloaden',
  BULK_DELETE_DRAFT_INVOICES: 'Geselecteerde conceptfacturen verwijderen',

  // Quotation Management
  CREATE_NEW_QUOTATION: 'Nieuwe offerte aanmaken',
  SAVE_QUOTATION: 'Offerte wijzigingen opslaan',
  DUPLICATE_QUOTATION: 'Maak een kopie van deze offerte',
  EDIT_QUOTATION: 'Offerte bewerken',
  FINALIZE_QUOTATION: 'Offerte definitief maken - kan niet ongedaan gemaakt worden',
  SEND_QUOTATION_EMAIL: 'Offerte per e-mail versturen',
  DOWNLOAD_QUOTATION_PDF: 'Offerte als PDF downloaden',
  CREATE_INVOICE_FROM_QUOTATION: 'Maak een factuur van deze offerte',
  OPEN_QUOTATION_SETTINGS: 'Offerte-instellingen openen',
  BULK_DOWNLOAD_QUOTATIONS: 'Geselecteerde offertes als ZIP downloaden',

  // Document Lines
  ADD_DOCUMENT_LINE: 'Nieuwe regel toevoegen',
  DELETE_DOCUMENT_LINE: 'Regel verwijderen',
  ADD_QUOTATION_LINE: 'Nieuwe regel toevoegen',

  // Filters
  OPEN_FILTERS: 'Filters openen',
  CLEAR_ALL_FILTERS: 'Alle filters wissen',
  APPLY_FILTERS: 'Filters toepassen',

  // Dashboard
  ADD_BANK_DETAILS: 'Bankgegevens toevoegen in instellingen',

  // Onboarding
  LOGOUT_ONBOARDING: 'Uitloggen en onboarding annuleren',
  PREVIOUS_STEP: 'Terug naar vorige stap',
  NEXT_STEP: 'Ga naar volgende stap',
  COMPLETE_ONBOARDING: 'Onboarding voltooien en account activeren',

  // Authentication
  LOGIN_BUTTON: 'Inloggen op je account',
  REGISTER_BUTTON: 'Nieuw account aanmaken',
  FORGOT_PASSWORD_LINK: 'Wachtwoord vergeten? Reset hier',
  GO_TO_LOGIN: 'Ga naar inlogpagina',
  GO_TO_REGISTER: 'Ga naar registratiepagina',
  BACK_TO_LOGIN: 'Terug naar inloggen',
  SEND_RESET_LINK: 'Wachtwoord reset link versturen',
  REQUEST_NEW_RESET_LINK: 'Nieuwe reset link aanvragen',
  RESET_PASSWORD_BUTTON: 'Nieuw wachtwoord instellen',

  // Company Settings
  CANCEL_TAX_CHANGE: 'BTW-wijziging annuleren',
  CONFIRM_TAX_CHANGE: 'BTW-wijziging bevestigen',
}

export const DYNAMIC_LABELS = {
  LOGGED_IN_AS: (user: string) => `Ingelogd als ${user}`,
  CONFIRM_REMOVE_CONTACT: (X: string) =>
    `Je staat op het punt om ${X} te verwijderen als contactpersoon. <br /> Weet je het zeker?`,
  INVOICE_NR: (nr: string) => `${LABELS.INVOICE} ${nr}`,
  INVOICE_CONCEPT_NR: (nr: string) => `${LABELS.INVOICE} ${nr} (concept)`,
  QUOTATION_NR: (nr: string) => `${LABELS.QUOTATION} ${nr}`,
  CONFIRM_BULK_DELETE_INVOICES_TITLE: (count: number) =>
    `${count} ${count === 1 ? 'conceptfactuur' : 'conceptfacturen'} verwijderen?`,
  CONFIRM_BULK_DELETE_INVOICES_TEXT: (count: number) =>
    `Weet je zeker dat je deze ${count} ${count === 1 ? 'conceptfactuur' : 'conceptfacturen'} wilt verwijderen? ` +
    'Deze actie kan niet ongedaan worden gemaakt.',
  CONFIRM_BULK_DELETE_QUOTATIONS_TITLE: (count: number) =>
    `${count} ${count === 1 ? 'conceptofferte' : 'conceptoffertes'} verwijderen?`,
  CONFIRM_BULK_DELETE_QUOTATIONS_TEXT: (count: number) =>
    `Weet je zeker dat je deze ${count} ${count === 1 ? 'conceptofferte' : 'conceptoffertes'} wilt verwijderen? ` +
    'Deze actie kan niet ongedaan worden gemaakt.',
}

export const LABELS_ABBR = {
  INVOICE_NUMBER: 'Nr',
  TOTAL: 'Totaal',
  CLIENT_NAME: 'Naam',
  REF: 'Ref',
  PAYMENT_STATUS: 'Betaling',
  QUOTATION_STATUS: 'Offerte',
}

export const ERRORS = {
  LOGIN: {
    FAILED: 'Er is iets misgegaan met inloggen. Probeer het nogmaals.',
  },
  SIGNUP: {
    FAILED: 'Het is niet gelukt om je aan te melden. Probeer het nogmaals.',
  },
  MICROSOFT_OAUTH: {
    PERSONAL_ACCOUNT:
      'Persoonlijke Microsoft-accounts (Hotmail/Outlook.com) worden niet ondersteund. ' +
      'Gebruik een zakelijk Microsoft 365-account of configureer SMTP met een app-wachtwoord.',
    FAILED: 'Verbinding met Microsoft is mislukt. Probeer het opnieuw.',
  },
}

export const WARNINGS = {
  NOT_ALLOWED: {
    NO_COMPANY: 'Het bezoeken van deze pagina is (nog) niet toegestaan. Vul eerst je gegevens in bij mijn onderneming.',
  },
}

export const FORM_LABELS = {
  REQUIRED: (field: string) => `${field} is verplicht`,
  INVALID: (field: string) => `${field} ongeldig`,
  INVALID_FORMAT: (field: string, example?: string) =>
    `${field} heeft een ongeldig formaat${example ? `. Bijv: ${example}` : ''}`,
  MIN_LENGTH: (field: string, min: number) => `${field} moet minimaal ${min} karakters bevatten`,
  MAX_LENGTH: (field: string, max: number) => `${field} mag maximaal ${max} karakters bevatten`,

  // Dutch-specific validation errors
  INVALID_POSTAL_CODE_NL: 'Postcode ongeldig (bijv: 1234AB)',
  INVALID_KVK_NUMBER: 'KVK nummer moet 8 cijfers bevatten',
  INVALID_BTW_ID_NL: 'BTW-ID ongeldig (bijv: NL123456789B01)',

  // International validation errors
  INVALID_VAT_NUMBER: 'BTW-ID ongeldig voor dit land',
  INVALID_EMAIL: 'E-mailadres heeft een ongeldig formaat',

  // Numeric validation
  HOURLY_RATE_NEGATIVE: 'Uurprijs kan niet negatief zijn',
  HOURLY_RATE_INTEGER: 'Uurprijs moet een geheel getal zijn',

  // Password validation
  PASSWORD_MIN_LENGTH: 'Wachtwoord moet minimaal 8 tekens bevatten',
  PASSWORD_UPPERCASE_REQUIRED: 'Wachtwoord moet minimaal één hoofdletter bevatten',
  PASSWORD_LOWERCASE_REQUIRED: 'Wachtwoord moet minimaal één kleine letter bevatten',
  PASSWORD_NUMBER_REQUIRED: 'Wachtwoord moet minimaal één cijfer bevatten',
  PASSWORD_COMPLEXITY: 'Wachtwoord moet minimaal 8 tekens, één hoofdletter, één kleine letter en één cijfer bevatten',
  PASSWORDS_MUST_MATCH: 'De wachtwoorden komen niet overeen',

  // Document line validation
  DOCUMENT_LINE_LABEL_MAX_LENGTH: 'Het label mag niet meer dan 255 tekens bevatten.',
  DOCUMENT_LINE_DESCRIPTION_MAX_LENGTH: 'De beschrijving mag niet meer dan 2.000 tekens bevatten.',
}

export const PLACEHOLDERS = {
  // Address fields
  STREET: 'Kalverstraat',
  HOUSE_NUMBER: '123',
  POSTAL_CODE: '1012AB',
  CITY: 'Amsterdam',

  // Contact fields
  EMAIL: 'naam@voorbeeld.nl',
  PHONE: '06-12345678',

  // Company/Client identifiers
  KVK_NUMBER: '12345678',
  BTW_ID_NL: 'NL123456789B01',

  // Password
  PASSWORD: '••••••••',

  // Banking
  IBAN: 'NL91ABNA0417164300',
}

export const HELPER_TEXT = {
  // Address fields
  POSTAL_CODE_NL: '4 cijfers gevolgd door 2 letters',

  // Contact fields
  EMAIL: 'E-mailadres van de klant',
  PHONE: 'Telefoonnummer (optioneel)',

  // Company/Client identifiers
  KVK_NUMBER: 'KVK-nummer (8 cijfers)',
  BTW_ID_NL: 'BTW-identificatienummer (bijv. NL123456789B01)',

  // Password
  PASSWORD_REQUIREMENTS: 'Minimaal 8 tekens, hoofdletter, kleine letter en cijfer',
  PASSWORD_CONFIRM: 'Vul hetzelfde wachtwoord nogmaals in',
  PASSWORD_CURRENT: 'Je huidige wachtwoord',
  PASSWORD_NEW: 'Je nieuwe wachtwoord',

  // Banking
  IBAN: 'IBAN nummer (bijv. NL91ABNA0417164300)',

  // Document lines
  DOCUMENT_LINE_LABEL: 'Maximaal 255 tekens',
  DOCUMENT_LINE_DESCRIPTION: 'Maximaal 2.000 tekens',

  // KVK limitations
  BTW_KVK_HINT: 'BTW-nummer wordt niet meegegeven door het KVK',
}
